module.exports = __webpack_public_path__ + "static/media/title.b9739ab7.png";